import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useSelector, useDispatch } from 'react-redux';
import { hideCtyDialog } from '../../redux/actions/dialogActions.js';
import {
  clearDate,
  setComment,
  setDate,
  setHour,
  setModule,
  setModType,
  setCty,
  setStage,
  setTask,
  setWpl,
  clearTask,
  clearStage,
} from '../../redux/actions/logActions.js';
import { resetCountryButtons, resetStateAndOverlay, handleModuleTypeLogChange, showMsg } from './utils/utils.js';
import ModuleTypesComponent from './utils/ModuleTypesComponent.js';
import SaveAndEditButtonComponent from './utils/SaveAndEditButtonsComponent.js';
import { dictionary } from '../../dictionary.js';
import DialogOverlay from './DialogOverlay.js';

const CountryComponent = (props) => {
  const dispatch = useDispatch();
  const dialogProps = props.dialogProps;
  const dateLog = new Date(useSelector((state) => state.date.value));
  const ctyLog = useSelector((state) => state.cty.value);
  const moduleLog = useSelector((state) => state.module.value);
  const modTypeLog = useSelector((state) => state.modType.value);
  const stageLog = useSelector((state) => state.stage.value);
  const taskLog = useSelector((state) => state.task.value);
  const hourLog = useSelector((state) => state.hours.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const commentLog = useSelector((state) => state.comment.value);
  const [index, setIndex] = useState(0);
  const [locChecked, setLockChecked] = useState(false);
  const [devChecked, setDevChecked] = useState(false);
  const toast = useRef(null);

  return (
    <>
      <Dialog
        header={dictionary.country_dialog_header}
        visible={dialogProps.isDialogOpen}
        style={{ width: '50vw' }}
        onHide={() => {
          dialogProps.setValuesOnInitialState();
          resetStateAndOverlay(setLockChecked, setDevChecked, dialogProps);
          dispatch(hideCtyDialog());
        }}
      >
        <div className="field field-wrapper">
          <Toast ref={toast} />
          <label>{dictionary.dialog_label_date}</label>
          {dialogProps.showOverlay && <DialogOverlay dialogProps={dialogProps} />}
          <Calendar
            disabledDays={dialogProps.disabledDays}
            style={{ width: '100%' }}
            placeholder={dateLog}
            value={dateLog}
            onChange={(e) => {
              if (dialogProps.checkIfDayIsPlanned(e.value)) {
                dispatch(setDate(e.value));
                dialogProps.setShowOverlay(false);
              } else {
                showMsg(toast, dictionary);
                dispatch(clearDate());
              }
            }}
            showIcon
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_country}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={ctyLog}
            options={dialogProps.eldData[0].countries}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setCty(e.value.name));
              setIndex(dialogProps.eldData[0].countries.indexOf(e.value));
            }}
            optionLabel="code"
            placeholder={ctyLog !== null ? ctyLog : dictionary.dialog_placeholder_country}
            className={ctyLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {ctyLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_country}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <div className={modTypeLog === null && dialogProps.formSubmitted ? 'row row-invalid' : 'row'}>
            <ModuleTypesComponent
              resetCountryButtons={resetCountryButtons}
              dispatch={dispatch}
              setModType={setModType}
              clearTask={clearTask}
              setModule={setModule}
            />
          </div>
          {modTypeLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_module_types}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          {moduleLog === null || moduleLog !== 'Hour management' ? (
            <>
              <label>{modTypeLog}:</label>
              <div className="field-dropdown-wrapper">
                <Dropdown
                  style={{ width: '100%' }}
                  value={moduleLog}
                  filter
                  filterInputAutoFocus
                  options={
                    dialogProps.eldData[0].length !== 0
                      ? handleModuleTypeLogChange(modTypeLog, dialogProps, index)
                      : null
                  }
                  onChange={(e) => {
                    dispatch(setModule(e.value.name));
                  }}
                  optionLabel="name"
                  placeholder={moduleLog !== null ? moduleLog : dictionary.dialog_placeholder_module}
                  className={moduleLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
                />
                {moduleLog === null && dialogProps.formSubmitted ? (
                  <small className="p-error">{dictionary.dialog_error_module}</small>
                ) : null}
                {moduleLog === 'Drobne_projekty' ? (
                  <>
                    <Dropdown
                      style={{ width: '100%', marginTop: '0.5rem' }}
                      value={taskLog}
                      options={dialogProps.eldData[0].projects_countries.sort((a, b) => a.name.localeCompare(b.name))} //Drobne_projekty
                      filter
                      filterInputAutoFocus
                      onChange={(e) => {
                        dispatch(setTask(e.value.name));
                      }}
                      optionLabel="name"
                      placeholder={taskLog !== null ? taskLog : dictionary.dialog_placeholder_task}
                      className={taskLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
                    />
                    {taskLog === null && dialogProps.formSubmitted ? (
                      <small className="p-error">{dictionary.dialog_error_task}</small>
                    ) : null}
                  </>
                ) : null}
              </div>
            </>
          ) : (
            <label>{modTypeLog}</label>
          )}
        </div>
        <div className="field field-stage-wrapper">
          <div className="row">
            <div className="col">
              <Button
                label={dictionary.dialog_button_label14}
                onClick={() => {
                  setLockChecked(true);
                  setDevChecked(false);
                  dispatch(clearStage());
                }}
                disabled={moduleLog === 'Drobne_projekty' || moduleLog === 'Hour management' ? true : locChecked}
              />
            </div>
            <div className="col">
              <Button
                label={dictionary.dialog_button_label15}
                onClick={() => {
                  setDevChecked(true);
                  setLockChecked(false);
                  dispatch(clearStage());
                }}
                disabled={moduleLog === 'Drobne_projekty' || moduleLog === 'Hour management' ? true : devChecked}
              />
            </div>
          </div>
          {moduleLog !== 'Hour management' ? (
            <div className="stage-dropdown-wrapper">
              {locChecked ? (
                <>
                  <label>{dictionary.dialog_label_stage}</label>
                  <Dropdown
                    style={{ width: '100%' }}
                    value={stageLog}
                    options={dialogProps.eldData[0].stages_localization}
                    filter
                    filterInputAutoFocus
                    onChange={(e) => {
                      dispatch(setStage(e.value.name));
                    }}
                    optionLabel="name"
                    placeholder={stageLog !== null ? stageLog : dictionary.dialog_placeholder_stage}
                    className={stageLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
                  />
                  {stageLog === null && dialogProps.formSubmitted ? (
                    <small className="p-error">{dictionary.dialog_error_stage}</small>
                  ) : null}
                </>
              ) : null}
              {devChecked ? (
                <>
                  <label>{dictionary.dialog_label_stage}</label>
                  <Dropdown
                    style={{ width: '100%' }}
                    value={stageLog}
                    options={dialogProps.eldData[0].stages_development}
                    filter
                    filterInputAutoFocus
                    onChange={(e) => {
                      dispatch(setStage(e.value.name));
                    }}
                    optionLabel="name"
                    placeholder={stageLog !== null ? stageLog : dictionary.dialog_placeholder_stage}
                    className={stageLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
                  />
                  {stageLog === null && dialogProps.formSubmitted ? (
                    <small className="p-error">{dictionary.dialog_error_stage}</small>
                  ) : null}
                </>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_hours}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={hourLog}
            options={dialogProps.eldData[0].hours}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setHour(e.value.hour));
            }}
            optionLabel="hour"
            placeholder={
              hourLog !== null && hourLog !== undefined ? String(hourLog) : dictionary.dialog_placeholder_hours
            }
            className={(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_hours}</small>
          ) : null}
        </div>
        {dialogProps.postEditing ? (
          <div className="field field-wrapper">
            <label>{dictionary.dialog_label_wpl}</label>
            <Dropdown
              style={{ width: '100%' }}
              value={wplLog}
              options={dialogProps.wplArr}
              onChange={(e) => {
                dispatch(setWpl(e.value.name));
              }}
              optionLabel="name"
              placeholder={wplLog !== 0 ? wplLog : dictionary.dialog_placeholder_wpl}
              className={wplLog === 0 && dialogProps.formSubmitted ? 'p-invalid' : null}
            />
            {wplLog === 0 && dialogProps.formSubmitted ? (
              <small className="p-error">{dictionary.dialog_error_wpl}</small>
            ) : null}
          </div>
        ) : null}
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_comment}</label>
          <InputText
            style={{ width: '100%' }}
            value={commentLog !== null ? commentLog : ''}
            placeholder={dictionary.dialog_placeholder_comment}
            onChange={(e) => {
              dispatch(setComment(e.target.value));
            }}
            className={
              moduleLog === 'Drobne_projekty' && commentLog === null && dialogProps.formSubmitted ? 'p-invalid' : null
            }
          />
          {moduleLog === 'Drobne_projekty' && commentLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_comment}</small>
          ) : null}
        </div>
        <SaveAndEditButtonComponent
          ctyLog={ctyLog}
          modTypeLog={modTypeLog}
          moduleLog={moduleLog}
          stageLog={stageLog}
          hourLog={hourLog}
          taskLog={taskLog}
          commentLog={commentLog}
          setLockChecked={setLockChecked}
          setDevChecked={setDevChecked}
          dispatch={dispatch}
          resetStateAndOverlay={resetStateAndOverlay}
          resetCountryButtons={resetCountryButtons}
          postEditing={dialogProps.postEditing}
          setFormSubbmited={dialogProps.setFormSubbmited}
          onLogSave={dialogProps.onLogSave}
          onRowEditComplete={dialogProps.onRowEditComplete}
          dialogProps={dialogProps}
        />
      </Dialog>
    </>
  );
};

export default CountryComponent;
